import { Button } from "components/Button/Button";
import './CourseLock.scss';

const CourseLock = ({ locked, lockedByCurrentUser, data, formatDate, handleLockToggle }) => {
	return (
		<div className="course-lock">
			<h1>Course Lock Control</h1>
			{!locked && <p>Courses must be locked to be editable.</p>}
			{locked && (
				<p>
					Course locked by {data.LockUsername} at{" "}
					{formatDate(data.LockTimestamp, true)}
				</p>
			)}
			<div className="course-lock-buttons">
				<Button
					text={locked ? "Unlock" : "Lock for Editing"}
					disabled={locked && !lockedByCurrentUser}
					onClick={handleLockToggle}
				/>
			</div>
		</div>
	);
};

export default CourseLock;
